module.exports = __webpack_public_path__ + "static/media/0050_Small.7fd8fc65.jpg";